if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      this.syncFilteredMedia();
      super.show(opener);
      this.showActiveMedia();
    }

    syncFilteredMedia() {
      const sectionId = this.id.replace('ProductModal-', '');
      const escapedSectionId = CSS.escape(sectionId);
      const sliderThumbnails = document.querySelectorAll(
        `#Slider-Thumbnails-${escapedSectionId} .thumbnail-list__item[data-target]`
      );
      const stackedThumbnails = document.querySelectorAll(
        `#ProductThumbnails-${escapedSectionId} .product__thumbnail[data-media-id]`
      );
      const thumbnails = sliderThumbnails.length ? sliderThumbnails : stackedThumbnails;

      let visibleMediaIds;

      if (thumbnails.length) {
        visibleMediaIds = new Set(
          [...thumbnails]
            .filter((media) => getComputedStyle(media).display !== 'none')
            .map((media) => (media.dataset.target || media.dataset.mediaId).split('-').pop())
        );
      } else {
        const gallery = document.querySelector(`#Slider-Gallery-${escapedSectionId}`);
        if (!gallery) return;

        visibleMediaIds = new Set(
          [...gallery.querySelectorAll('.product__media-item[data-media-id]')]
            .filter((media) => getComputedStyle(media).display !== 'none')
            .map((media) => media.dataset.mediaId.split('-').pop())
        );
      }

      if (visibleMediaIds.size === 0) return;

      this.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach((media) => {
        media.classList.toggle('hidden', !visibleMediaIds.has(media.dataset.mediaId));
      });
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('is-active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      if (!activeMedia) return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('is-active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
